/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { EtiologyTypeDtoName } from './etiologyTypeDtoName';

export interface EtiologyTypeDto {
  /** Etiology type code */
  code: string;
  /** Etiology type name (multilingual) */
  name: EtiologyTypeDtoName;
}
